var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"btn-back",attrs:{"to":_vm.redirect}},[_c('b-icon-arrow-left')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }